import React from "react";
import { Box } from "@mui/material";
import VpnKeyOutlined from "@mui/icons-material/VpnKeyOutlined";
import { SectionHeader } from "../layout/SectionHeader";
import { FormField } from "../fields/FormField";
import { ProfileFormGrid } from "../ProfileFormGrid";
import { profileSubsectionShellSx } from "../../profileFieldStyles";

export function CredenzialiCatalogo({ vendorForm, fieldErrors, onChange, readOnly = false }) {
  const v = vendorForm ?? {};
  const err = fieldErrors ?? {};

  return (
    <Box sx={profileSubsectionShellSx}>
      <SectionHeader title="Credenziali catalogo" icon={VpnKeyOutlined} />
      <ProfileFormGrid>
        <FormField
          name="urlSftp"
          value={v.urlSftp}
          errorMessage={err.urlSftp}
          onChange={onChange}
          readOnly={readOnly}
        />
        <FormField
          name="utenteSftp"
          value={v.utenteSftp}
          errorMessage={err.utenteSftp}
          onChange={onChange}
          readOnly={readOnly}
        />
        <FormField
          name="passwordSftp"
          value={v.passwordSftp}
          errorMessage={err.passwordSftp}
          onChange={onChange}
          readOnly={readOnly}
        />
      </ProfileFormGrid>
    </Box>
  );
}
